import { render, staticRenderFns } from "./SettingDevice.vue?vue&type=template&id=230ef1c2&scoped=true&"
import script from "./SettingDevice.vue?vue&type=script&lang=js&"
export * from "./SettingDevice.vue?vue&type=script&lang=js&"
import style0 from "./SettingDevice.vue?vue&type=style&index=0&id=230ef1c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230ef1c2",
  null
  
)

export default component.exports